<div *ngIf="_edm.editing" class="inline">
    <p class="inline bold" style="margin-left: 8px;">{{_adding ? "Adding an Exposure Custom Survey Measure" : "Editing an Exposure Custom Survey Measure" }}</p>
    <img style="margin-left: 10px; height: 38px; width: 38px;margin-top:4px;" class="inline" src="assets/images/MeasureDataValue_Blue.png" />
</div>

<div class="row">
    <i *ngIf="isLoading" class="fa fa-circle-o-notch fa-spin" style="font-size:38px; color: #337ab7;"></i>
</div>

<div *ngIf="_validationMessage">
    <p class="alert-danger">{{_validationMessage}}</p>
</div>

<div *ngIf="!_edm.editing">
    <div style="margin-top: 12px; margin-left: 6px;">
        <div class="row inline">
            <button type="button" class="inline btn btn-choose-material" style="margin-left: 19px; margin-top: -2px;" (click)="selectMaterial()">Choose Material</button>
            <div *ngIf="_selectedMaterial" class="left-indent inline">
                <span class="bold inline">Selected CAS No.: </span>
                <a class="inline bold some-space" (click)="onShowMaterial(_selectedMaterial)">{{_selectedMaterial.realCASNumber || '(No CAS#)'}}</a>

                <span class="bold inline left-indent">RIFM Id: </span>
                <span class="form-control-static some-space">{{_selectedMaterial.formattedRIFMId + ','}}</span>

                <span class="bold inline some-space">Principal Synonym: </span>
                <span class="form-control-static some-space" [htmlGreek]="_selectedMaterial.principalSynonym().synonymWordOrWebVersion()"></span>
            </div>
        </div>
    </div>

</div>

<div class="row" style="margin-left: 10px; margin-top: 20px;">
    <editor-header [edm]="_edm" [customButtons]="true" style="margin-left: -4px !important;">
        <span customButtons>
            <button *ngIf="!_edm.editing" type="button" class="btn btn-sm btn-primary" [disabled]="!canSave()" (click)="onSave()">Save</button>
            <button *ngIf="_edm.editing" type="button" class="btn btn-sm btn-primary" [disabled]="!canApply()" (click)="onApply()">Apply</button>
            <button *ngIf="canShowBack()" type="button" class="btn btn-sm btn-primary" (click)="onBack()">Back</button>
            <button *ngIf="canCancel()" type="button" class="btn btn-sm btn-primary" (click)="onCancel()">Cancel</button>
        </span>
    </editor-header>
    <button *ngIf="(canAdd())" type="button" class="inline btn btn-survey-measure" style="width:130px; margin-left: 0px;" (click)="onAdd()">Add Measure</button>
</div>

<div *ngIf="!_edm.editing">
    <div style="margin-left: 10px; background-color: white;">
        <h4 *ngIf="(hasNoCustomMeassureData())">
            There is no Custom Survey Measure data for this material.
        </h4>
        <span *ngIf="_materialExposureCustomSurveyMeasuresEx != null && _materialExposureCustomSurveyMeasuresEx.length > 0" class="inline">
            <span class="bold inline subtitle-margin-top" header>Exposure Custom Survey Measure Data</span>
        </span>
        <default-table *ngIf="_materialExposureCustomSurveyMeasuresEx != null && _materialExposureCustomSurveyMeasuresEx.length > 0">
            <thead>
            <tr>
                <td>Edit</td>
                <td>Remove</td>
                <td>Custom Survey Date</td>
                <td>Measure</td>
                <td>Value</td>
                <td>Date Entered</td>
                <td>Notes</td>
                <td>Creme Version</td>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let mx of _materialExposureCustomSurveyMeasuresEx">
                <td><a (click)="onEdit(mx)">Edit</a></td>
                <td><a (click)="onRemove(mx)">Remove</a></td>
                <td>{{utilFns.formatDate(mx.data.customSurveyDate)}}</td>
                <td>{{mx.data.typeExposureMeasure.measureDescription}}</td>
                <td>{{mx.data.measureQualitativeResult || utilFns.formatNumber(mx.data.measureQuantitativeResult, 12, 4)}}</td>
                <td>{{utilFns.formatDate(mx.data.created)}}</td>
                <td class="text-left">{{mx.data.measureNotes}}</td>
                <td class="text-center">{{mx.data.typeCremeVersion.cremeVersion}}</td>
            </tr>
            </tbody>
        </default-table>
    </div>
</div>

<material-selector></material-selector>

<div *ngIf="_edm.editing" style="margin-bottom: 10px;">
    <material-exposure-custom-survey-measure-editor #self [entity]="_edm.currentEntity"></material-exposure-custom-survey-measure-editor>
</div>
